import hoteltv from "../pages/hoteltv/routes";
import search from "../pages/search/routes";
import livetv from "../pages/livetv/routes";


export default [...hoteltv, ...search, ...livetv];